export default class CategoryDto {
    /**
     * @type{number}
     * */
    ctId;

    /**
     * @type{string}
     */
    ctName;

    /**
     * @type{number}
     */
    ctSortSeq;

    /**
     * @type{boolean}
     */
    recurring;

    /**
     * @type{Object<string, string>}
     */
    names;

    /**
     * @type{string[]}
     */
    manualLocales;

    constructor () {
        this.ctId = 0;
        this.ctName = '';
        this.ctSortSeq = 0;
        this.names = {};
        this.manualLocales = [];
    }
}
